import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError, timer, Subject, BehaviorSubject } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import * as _ from 'lodash';
import { SettingsService } from './settings.service';
import * as moment from 'moment';
import { of } from 'rxjs/observable/of';
import { environment } from '../../../environments/environment';
import { ElevationService } from '../../shared/services/elevation.service';

const timer1 = timer(1000);

@Injectable({
  providedIn: 'root',
})
export class Employee {
  id: string;
  name: string;
  email: string;
  phone: number;
}

@Injectable({
  providedIn: 'root',
})
export class ApiSettingsService {
  authKey = this.appSettings.configSettings.authKey;
  apiKey = this.appSettings.configSettings.apiKey;
  apiHeader = {
    site_uuid: '3ed9303c-f34f-d395-7d12-3403faac3f8b',
    dco_site_id: 1,
    datatype: 1,
    auth_key: this.authKey,
    api_key: this.apiKey,
  };
  apiMethods = {
    get: {
      method: 'GET',
      headers: this.apiHeader,
    },
    post: {
      method: 'POST',
      transformRequest: function (data) {
        return $.param(data);
      },
      headers: _.extend(
        { 'Content-Type': 'application/x-www-form-urlencoded' },
        this.apiHeader,
      ),
    },
    save: {
      method: 'POST',
      headers: this.apiHeader,
    },
    query: {
      method: 'GET',
      isArray: true,
      headers: this.apiHeader,
    },
    remove: {
      method: 'DELETE',
      headers: this.apiHeader,
    },
    delete: {
      method: 'POST',
      headers: _.extend({}, this.apiHeader, {
        'X-HTTP-Method-Override': true,
        method: 'DELETE',
      }),
    },
    add: {
      method: 'POST',
      headers: this.apiHeader,
    },
    update: {
      method: 'PUT',
      headers: this.apiHeader,
    },
  };
  //    var apiHeader = {site_uuid:'3ed9303c-f34f-d395-7d12-3403faac3f8b',datatype:1,auth_key:appSettings.configSettings.apiKey};
  getApiHeader = () => {
    return {
      site_uuid: '3ed9303c-f34f-d395-7d12-3403faac3f8b',
      dco_site_id: 1,
      datatype: 1,
      auth_key: this.appSettings.configSettings.authKey,
      api_key: this.appSettings.configSettings.apiKey,
    };
  };

  constructor(private appSettings: SettingsService) {}

  getApiMethods = () => {
    _.each(this.apiMethods, function (d, k) {
      this.apiMethods[k].headers.auth_key =
        this.appSettings.configSettings.authKey;
      this.apiMethods[k].headers.api_key =
        this.appSettings.configSettings.apiKey;
    });
    return this.apiMethods;
  };
}

@Injectable({
  providedIn: 'root',
})
export class AccessService {
  // Define API
  private nestElevationApiUrl = environment.nestElevationApiUrl;

  //https://blog.angular-university.io/how-to-build-angular2-apps-using-rxjs-observable-data-services-pitfalls-to-avoid/
  private mee$: BehaviorSubject<any> = new BehaviorSubject({});
  public readonly mee: Observable<any> = this.mee$.asObservable();

  // ------ Creating the observable ----------
  // Create a subject - The thing that will be watched by the observable
  public me: any = new Subject();

  // Create an observable to watch the subject and send out a stream of updates (You will subscribe to this to get the update stream)
  public me$ = this.me.asObservable(); //Has a $

  apiHeader = this.apiSettings.getApiHeader();
  ownedAccounts: {
    new_customers: string[];
    customer: string[];
    previous_client: string[];
    initial_onboarding: string[];
    pause: string[];
    all_accounts: string[];
  };

  user: any = {};
  constructor(
    private http: HttpClient,
    private appSettings: SettingsService,
    private apiSettings: ApiSettingsService,
    private elevation: ElevationService,
  ) {}

  // ------ Getting Your updates ----------
  // Subscribe to the observable you created.. data will be updated each time there is a change to Subject

  getMe(): any {
    return this.me;
  }
  getUser(): any {
    return this.user;
  }
  checkUserAccess(api_key): Observable<any> {
    if (
      _.has(this.me, 'status') &&
      _.has(this.me, 'groups') &&
      this.me.auth_expiry > moment().unix()
    ) {
      return of(this.me);
    }
    return this.checkAuth(api_key).pipe(
      switchMap((rs) => {
        //switchMap used when combining observables
        this.user = rs;
        this.me.status = rs.status;
        this.me.auth_expiry = rs.auth_expiry;
        //this.me = response;
        if (rs.status == 0) {
          this.mee$.next(rs);
          this.me.next(rs);
          return of(this.me);
        }
        return this.http
          .post(
            `${this.nestElevationApiUrl}/access/myGroups`,
            _.omitBy({ rand: moment().unix(), api_key }, _.isNull),
          )
          .pipe(
            map((myGroups) => {
              rs = _.extend(rs, { groups: myGroups });
              this.me.groups = myGroups;
              this.appSettings.configSettings.apiKey = rs.api_key;
              this.appSettings.set(this.appSettings.configSettings);
              this.mee$.next(rs);
              this.me.next(rs);
              this.elevation
                .getData('/access/getAuthorizedAccounts', this.me.groups)
                .subscribe((res) => (this.me.authorizedAccounts = res));

              return this.me;
            }),
          );
      }),
    );
  }
  isInGroup = (group_name, value) => {
    return (
      _.has(this.me, 'groups') && _.includes(this.me.groups[group_name], value)
    );
  };

  /*========================================
    CRUD Methods for consuming RESTful API
  =========================================*/
  // Http Options
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
  };

  login(data): Observable<any> {
    return this.http.post(`${this.nestElevationApiUrl}/access/login`, data);
  }

  logout(data): Observable<any> {
    return this.http.post(`${this.nestElevationApiUrl}/access/logout`, data);
  }

  checkAuth(api_key?): Observable<any> {
    return this.http.get(
      `${this.nestElevationApiUrl}/access/checkAuth`,
      _.omitBy({ rand: moment().unix(), api_key: api_key }, _.isNull),
    );
  }
  isAuthenticated() {
    return _.has(this, 'me.groups') && this.me.status == 1;
  }

  // Error handling
  handleError(error) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    //window.alert(errorMessage);
    return throwError(errorMessage);
  }
}
